import { ITooltipHostProps, Stack } from '@fluentui/react';
import { CSSProperties, FCWithChildren } from 'react';
import { nameof } from '../../utils/stringUtils';
import { ErrorMessage, LabelWithHint } from '../../shared/styled-components';

interface IProps {
    required?: boolean;
    disabled?: boolean;
    label: string;
    id?: string;
    hint?: ITooltipHostProps['content']
    errorMessage?: string | JSX.Element;
    style?: CSSProperties;
}

const InlineControl: FCWithChildren<IProps> = ({ children, required, disabled, label, id, hint, errorMessage, style }) => (
    <div>
        <Stack horizontal horizontalAlign="space-between" verticalAlign="center" tokens={{ childrenGap: '0.5rem' }} style={style}>
            <LabelWithHint htmlFor={id ? `#${id}` : undefined} required={required} disabled={disabled} hint={hint}>{label}</LabelWithHint>
            {children}
        </Stack>
        {errorMessage && <ErrorMessage textAlign="end">{errorMessage}</ErrorMessage>}
    </div>
);

InlineControl.displayName = nameof({ InlineControl });
export default InlineControl;